import {gql} from "@apollo/client";

export const Formula = {
    formulaKeyword: "formulaKeyword"
}

export const GET_FORMULA_BY_TYPES = gql`
query  getFormulaKeyword(
    $type: String
) {
    ${Formula.formulaKeyword}(
        type: $type
    ) {
        items {
            column
            name
            defaultValue
            example
            note
            type
            customFormula
            value
            newColumn
        }
        page
        pageSize
        totalCount
    }
}`

